import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowDown } from 'lucide-react';
export function ProductRevealSection() {
  const includes = ["Guida completa all'alimentazione infantile sana", 'Oltre 200 ricette veloci e pratiche per colazioni, pranzi e merende', 'Menù settimanali pronti e liste della spesa organizzate', 'Suggerimenti di combinazioni per merende nutrienti e gustose', 'Opzioni adatte alla congelazione per risparmiare tempo', 'Lista di sostituti degli ingredienti per adattarsi a ciò che hai in casa', 'Struttura di un pasto equilibrato: cosa includere e cosa evitare'];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-157">
      <div className="max-w-4xl mx-auto text-center" data-id="element-158">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] mb-12" data-id="element-159">
          Riceverai con il tuo accesso:
        </h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-md mx-auto mb-12" data-id="element-160">
          {/* Mockup of ebook cover */}
          <div className="relative aspect-[3/4] bg-white rounded-r-3xl rounded-l-md shadow-2xl border-l-8 border-[#1f2e10] overflow-hidden transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-161">
            <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-green-100 p-6 flex flex-col items-center justify-center text-center" data-id="element-162">
              <span className="bg-[#c4f000] text-[#1f2e10] text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-163">
                EBOOK DIGITALE
              </span>
              <h3 className="text-4xl font-black text-[#1f2e10] mb-4 leading-tight" data-id="element-164">
                MERENDE
                <br data-id="element-165" />
                FELICI™
              </h3>
              <img src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80&w=400" alt="Cibo sano" className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg mb-4" data-id="element-166" />
              <p className="text-sm font-medium text-green-800" data-id="element-167">
                Oltre 200 Ricette Sane
              </p>
            </div>
          </div>
        </motion.div>

        <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 text-left max-w-2xl mx-auto mb-12" data-id="element-168">
          <div className="text-center mb-6" data-id="element-169">
            <span className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-170">
              INCLUDE
            </span>
            <h3 className="text-2xl font-bold text-[#1f2e10]" data-id="element-171">
              Merende Felici™
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-172">
            {includes.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-173">
                <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-174">
                  <Check size={16} className="text-green-600" data-id="element-175" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-176">{item}</span>
              </motion.li>)}
          </ul>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-177">
          <p className="text-xl font-bold text-[#1f2e10]" data-id="element-178">E molto di più...</p>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5
        }} data-id="element-179">
            <ArrowDown size={32} className="text-green-600" data-id="element-180" />
          </motion.div>
        </div>
      </div>
    </section>;
}